import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class GuidedOnboardingWizardTour extends TourBase {
	@service('flow/tour/onboarding')
	declare flowTourOnboardingService: Service.Flow.Tour.Onboarding;

	get id(): string {
		return TourId.GUIDED_ONBOARDING__WIZARD;
	}

	override get stepData(): StepData[] {
		return [
			{
				step: 1,
				direction: Direction.DOWN,
				attachTo: () => {
					return $('#page-boards .card.card--placeholder-new');
				},
				scrollToAttachTo: true,
				doAction: () => {
					$('#page-boards .card.card--placeholder-new').trigger('click');
				},
				focusOverlay: {
					show: true,
					offset: {
						left: -24,
						top: -24,
						width: 48,
						height: 48,
					},
				},
			},
			{
				step: 2,
				direction: Direction.DOWN,
				attachTo: () => {
					const $el = $('#page-boards .card.card--placeholder-new .option .option__top');

					return $el.length ? $el : $('#page-boards .card.card--placeholder-new .option');
				},
				focusOverlay: {
					show: true,
				},
			},
			{
				step: 3,
				direction: Direction.DOWN,
				attachTo: () => {
					return $(
						'.sources-wrapper.sources-wrapper--connected .card.card--source-type',
					).eq(0);
				},
				focusOverlay: {
					show: true,
					offset: {
						left: -12,
						top: -12,
						width: 24,
						height: 24,
					},
					el: () => {
						return $('.sources-wrapper.sources-wrapper--connected');
					},
				},
			},
			{
				step: 4,
				direction: Direction.DOWN,
				attachTo: () => {
					return $('.onboarding-guided-tour-banner a.continue');
				},
				focusOverlay: {
					show: true,
					el: () => {
						return $('.onboarding-guided-tour-banner');
					},
				},
			},
			{
				step: 5,
				direction: Direction.UP,
				attachTo: () => {
					return $(
						'.metrics-wrapper.metrics-wrapper-metrics-per-source-type .card.card--small-metric-type',
					);
				},
				focusOverlay: {
					show: true,
					offset: {
						left: -12,
						top: -12,
						width: 24,
						height: 24,
					},
					el: () => {
						return $('.metrics-wrapper.metrics-wrapper-metrics-per-source-type');
					},
				},
			},
			{
				step: 6,
				direction: Direction.DOWN,
				attachTo: () => {
					return $('.onboarding-guided-tour-banner a.continue');
				},
				focusOverlay: {
					show: true,
					el: () => {
						return $('.onboarding-guided-tour-banner');
					},
				},
			},
			{
				step: 7,
				direction: Direction.UP,
				attachTo: () => {
					return $('.step-connect .main-wrapper').eq(0);
				},
				focusOverlay: {
					show: true,
					offset: {
						left: -12,
						top: -12,
						width: 24,
						height: 24,
					},
				},
			},
			{
				step: 8,
				direction: Direction.DOWN,
				attachTo: () => {
					return $('.onboarding-guided-tour-banner a.continue');
				},
			},
		];
	}
}
